webpackJsonp([174025652018953],{

/***/ 1648:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"AnalyticsDataRow","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"breakdowns","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"AnalyticsDataRowBreakdown","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"date","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"modifiers","type":{"kind":"LIST","name":null,"ofType":{"kind":"ENUM","name":"AnalyticsDataRowModifier","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"total","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-analytics-data-row-35cfc16411f125e245e9.js